import { render, staticRenderFns } from "./ProposalStaging.vue?vue&type=template&id=4452e283&scoped=true"
import script from "./ProposalStaging.vue?vue&type=script&lang=js"
export * from "./ProposalStaging.vue?vue&type=script&lang=js"
import style0 from "./ProposalStaging.vue?vue&type=style&index=0&id=4452e283&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4452e283",
  null
  
)

export default component.exports